<script setup>
import { computed } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import { useMessageContext } from '../provider.js';
import { useVoiceCallStatus } from 'dashboard/composables/useVoiceCallStatus';

const { contentAttributes } = useMessageContext();

const data = computed(() => contentAttributes.value?.data);

const status = computed(() => data.value?.status);
const direction = computed(() => data.value?.call_direction);
const title = computed(() => data.value?.title);
const subtitle = computed(() => data.value?.subtitle);

const { labelKey, subtextKey, bubbleIconBg, bubbleIconName } =
  useVoiceCallStatus(status, direction);

const containerRingClass = computed(() => {
  return status.value === 'ringing' ? 'ring-1 ring-emerald-300' : '';
});

const resolvedTitle = computed(() => {
  return title.value || labelKey.value;
});

const resolvedSubtitle = computed(() => {
  return subtitle.value || subtextKey.value;
});

const titleIsTranslationKey = computed(() => resolvedTitle.value.includes('.'));
const subtitleIsTranslationKey = computed(() =>
  resolvedSubtitle.value.includes('.')
);

const iconSize = computed(() => 18);
</script>

<template>
  <BaseBubble class="p-0 border-none" hide-meta>
    <div
      class="flex overflow-hidden flex-col w-full max-w-xs bg-white rounded-lg border border-slate-100 text-slate-900 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
      :class="containerRingClass"
    >
      <div class="flex gap-3 items-center p-3 w-full">
        <div
          class="flex justify-center items-center rounded-full size-10 shrink-0"
          :class="bubbleIconBg"
        >
          <fluent-icon
            icon="call"
            :size="iconSize"
            class="text-white drop-shadow-[0_1px_1px_rgba(0,0,0,0.16)]"
          />
        </div>

        <div class="flex overflow-hidden flex-col flex-grow">
          <span class="text-base font-medium truncate">
            {{ titleIsTranslationKey ? $t(resolvedTitle) : resolvedTitle }}
          </span>
          <span class="text-xs text-slate-500">
            {{
              subtitleIsTranslationKey
                ? $t(resolvedSubtitle)
                : resolvedSubtitle
            }}
          </span>
        </div>
      </div>
    </div>
  </BaseBubble>
</template>
